<!--
 * @Author: Axs <i@axs.email>
 * @Date: 2020-08-20 16:32:34
 * @LastEditors: Axs <i@axs.email>
 * @LastEditTime: 2022-02-09 16:53:43
 * @Description: 
 * @FilePath: /src/page/customer-service/index.vue
-->
<template>
    <div class="page">
        <!-- <iframe :src="iframeUrl"
                :style="{height:ifHeight}"
                class="iframe"></iframe> -->
    </div>
</template>
<script>
export default {
    data() {
        return {};
    },
    computed: {
        // kfDomain(){
        //     return this.$store.getters.getExposeMethod.kfDomain || '//kf.qianzhu8.com';
        // }
    },
    created() {
        var orderNo = this.$route.query.orderNo;
        var noLogin = this.$route.query.noLogin || 0;
        this.$util.getCustomerService(orderNo, noLogin).then(res => {
            if (res.url.indexOf('tel:') > -1) {
                window.location.replace(res.url);
                setTimeout(() => {
                    this.$util.pageBack();
                }, 1000);
            } else {
                window.location.replace(res.url);
            }
        });
    },
    methods: {},
};
</script>

<style lang="less" scoped>
.iframe {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    border: none;
    width: 100vw;
}
</style>
